<script lang="ts">
  import DashboardLayout from '../DashboardLayout.svelte';
  import DashHero from '../shared/DashHero.svelte';
  import QuickActions from '../widgets/QuickActions.svelte';
  import KpiCard from '../widgets/KpiCard.svelte';
  import { Reportes } from '../../../lib/api';

  let { onNavigate }: { onNavigate: (tab: string) => void } = $props();

  let egresos = $state(0);
  let defunciones = $state(0);
  let infecciones = $state(0);
  let indicadores = $state<Record<string, unknown> | null>(null);
  let error = $state<string | null>(null);

  function rangoMes() {
    const d = new Date();
    const desde = new Date(d.getFullYear(), d.getMonth(), 1).toISOString().slice(0, 10);
    const hasta = d.toISOString().slice(0, 10);
    return { desde, hasta };
  }

  async function cargar() {
    error = null;
    const { desde, hasta } = rangoMes();
    try {
      const [eg, def, inf, ind] = await Promise.all([
        Reportes.egresos().catch(() => []),
        Reportes.defunciones().catch(() => []),
        Reportes.infecciones().catch(() => []),
        Reportes.indicadores(desde, hasta).catch(() => null),
      ]);
      egresos = eg.length;
      defunciones = def.length;
      infecciones = inf.length;
      indicadores = ind;
    } catch (e: any) {
      error = e?.message ?? String(e);
    }
  }

  const actions = [
    { id: 'reportes', label: 'Reportes MSPAS', icon: '' },
    { id: 'ingresos', label: 'Ingresos', icon: '' },
    { id: 'altas', label: 'Altas', icon: '' },
  ];

  function num(k: string): string {
    const v = indicadores?.[k];
    if (v == null) return '—';
    return String(v);
  }

  $effect(() => { cargar(); const t = setInterval(cargar, 120000); return () => clearInterval(t); });
</script>

<DashboardLayout title="Indicadores MSPAS" subtitle="Reportes regulatorios del hospital" variant="mspas">
  <DashHero emoji='' title="Indicadores MSPAS" subtitle="Egresos, defunciones, infecciones e indicadores del periodo" variant="mspas" />
  <QuickActions {actions} onAction={onNavigate} />

  {#if error}<p class="err">{error}</p>{/if}

  <div class="dash-kpis">
    <KpiCard label="Egresos registrados" value={egresos} tone="neutral" />
    <KpiCard label="Defunciones" value={defunciones} tone="danger" />
    <KpiCard label="Infecciones" value={infecciones} tone="warning" />
    <KpiCard label="Periodo" value={new Date().toLocaleDateString('es-GT', { month: 'short', year: 'numeric' })} tone="brand" />
  </div>

  <div class="dash-grid">
    <div class="col-12">
      <div class="glass-panel">
        <header><h3>Indicadores del mes</h3></header>
        <div class="ind-grid">
          <div class="ind-item"><span class="k">Camas operativas</span><strong>{num('camasOperativas')}</strong></div>
          <div class="ind-item"><span class="k">Días cama disponibles</span><strong>{num('diasCamaDisponibles')}</strong></div>
          <div class="ind-item"><span class="k">Días cama ocupados</span><strong>{num('diasCamaOcupados')}</strong></div>
          <div class="ind-item"><span class="k">Tasa ocupación</span><strong>{num('tasaOcupacion')}</strong></div>
          <div class="ind-item"><span class="k">Consultas externas</span><strong>{num('consultasExternas')}</strong></div>
          <div class="ind-item"><span class="k">Emergencias</span><strong>{num('emergencias')}</strong></div>
        </div>
        {#if !indicadores && !error}
          <p class="empty">Sin datos de indicadores — use el módulo Reportes para capturar.</p>
        {/if}
      </div>
    </div>
  </div>
</DashboardLayout>

<style>
  .err { color: var(--danger); font-size: 0.88rem; }

  .glass-panel {
    background: var(--glass-bg-card);
    backdrop-filter: var(--glass-blur);
    -webkit-backdrop-filter: var(--glass-blur);
    border: 1px solid var(--glass-border);
    border-radius: var(--radius-xl);
    overflow: hidden;
    box-shadow: var(--glass-shadow);
  }

  header {
    padding: 0.75rem 1.1rem;
    border-bottom: 1px solid var(--glass-border);
    background: rgba(255,255,255,0.35);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
  }

  h3 { margin: 0; font-size: 0.88rem; color: var(--text-primary); font-weight: 700; }

  .ind-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
    gap: 0.85rem;
    padding: 1.1rem;
  }

  .ind-item {
    padding: 0.75rem 0.85rem;
    background: rgba(255,255,255,0.4);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    border: 1px solid var(--glass-border);
    border-radius: var(--radius-lg);
    transition: box-shadow 0.2s ease;
  }

  .ind-item:hover {
    box-shadow: var(--glass-shadow);
  }

  .k { display: block; font-size: 0.7rem; color: var(--text-secondary); margin-bottom: 0.2rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.03em; }
  strong { font-size: 1.15rem; color: var(--text-primary); font-weight: 800; }

  .empty { padding: 1.1rem; margin: 0; font-size: 0.85rem; color: var(--text-secondary); }
</style>
